import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import Panel from '../../components/panel/panel';
import './account.less';
import { fetchLenderAccount, fetchLoan, fetchLoans } from './accountActions';
import { getError, isBusy, withActions } from 'actionware';
import { Alert, Spin, Tabs } from 'antd';
import ItemList from '../../components/itemList/itemList';

@withRouter
@connect(
  ({ localize, account: { activeLoans, repaidLoans, selectedLoanDetails } }) => ({
    translate: getTranslate(localize),
    loading: isBusy(fetchLoans) || isBusy(fetchLenderAccount),
    error: getError(fetchLoans),
    activeLoans,
    repaidLoans,
    selectedLoanDetails
  })
)
@withActions({
  fetchLoan
})
export default class AccountLoans extends PureComponent {
  wrapContent(content) {
    return (
      <Panel className={'loan-list'} unpadded>
        {content}
      </Panel>
    );
  }

  onClickLoan = (data) => {
    this.props.fetchLoan(data.id, data.accountId);
  };

  render() {
    const {
      translate,
      loading,
      error,
      activeLoans,
      repaidLoans,
      selectedLoanDetails
    } = this.props;

    if (loading) {
      return this.wrapContent(
        <Spin tip={translate('generic.loadingData')} size="large" />
      );
    }

    if (error) {
      return this.wrapContent(
        <Alert
          message={translate('generic.loadingErrorCaption')}
          description={translate('generic.loadingErrorMessage')}
          type="error"
          showIcon
        />
      );
    }
    const selectedId = selectedLoanDetails.contractId;
    const accountId = R.path(['params', 'accountId'], this.props.match)

    return this.wrapContent(
      <Tabs animated={false} defaultActiveKey="1">
        <Tabs.TabPane tab={translate('account.activeLoans')} key="1">
          <ItemList>
            {activeLoans.map(({ id, contractId, interestRate, tenor }) => (
              <ItemList.Item
                key={id}
                active={contractId === selectedId}
                action={this.onClickLoan.bind(this, {id, accountId})}
              >
                <h3>{contractId}</h3>
                {(interestRate * 100).toFixed(2)}% / {tenor}
              </ItemList.Item>
            ))}
          </ItemList>
        </Tabs.TabPane>
        <Tabs.TabPane tab={translate('account.fullyPaidLoan')} key="2">
          <ItemList>
            {repaidLoans.map(({ id, contractId, interestRate, tenor }) => (
              <ItemList.Item
                key={id}
                active={contractId === selectedId}
                action={this.onClickLoan.bind(this, {id, accountId})}
              >
                <h3>{contractId}</h3>
                {(interestRate * 100).toFixed(2)}% / {tenor}
              </ItemList.Item>
            ))}
          </ItemList>
        </Tabs.TabPane>
      </Tabs>
    );
  }
}
